import { render, staticRenderFns } from "./PostaEdit.vue?vue&type=template&id=0c1921f8&scoped=true&"
import script from "./PostaEdit.vue?vue&type=script&lang=js&"
export * from "./PostaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1921f8",
  null
  
)

export default component.exports